import { useState } from "react";
import CambiarContraseña from "../../page/login/CambiarContraseña";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";
import { useNavigate, useParams } from "react-router-dom";

const ContraseñaController = () => {
  const navigation = useNavigate();
  const { token } = useParams();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    password: "",
    confirm_password: "",
  });

  const onClick = async (e) => {
    switch (e.target.name) {
      case "enviar":
        {
          setLoading(true);

          // Validaciones frontend
          if (
            form.password.trim() == "" ||
            form.confirm_password.trim() == ""
          ) {
            setLoading(false);
            return Alerts({
              msg: "Alert",
              title: "Todos los campos son obligatorios",
              code: "401",
              type: "error",
            });
          }

          if (form.password !== form.confirm_password) {
            setLoading(false);
            return Alerts({
              msg: "Alert",
              title: "Las contraseñas no coinciden",
              code: "401",
              type: "error",
            });
          }

          if (form.password.length < 8) {
            setLoading(false);
            return Alerts({
              msg: "Alert",
              title: "La contraseña debe tener al menos 8 caracteres",
              code: "401",
              type: "error",
            });
          }
          let dataForm = new FormData();
          dataForm.append("password", form.password);
          dataForm.append("password_confirmation", form.confirm_password);
          dataForm.append("token", token);

          const response = await RestPrivateAntesala({
            method: "post",
            url: "/auth/recuperar-contraseña",
            formData: dataForm,
            setLoading: setLoading,
          });

          if (response.status == 201 || response.status == 200) {
            Alerts({
              msg: "Éxito",
              title: response.data.msg || "Contraseña restaurada correctamente",
              code: "200",
              type: "success",
            });

            return navigation("/login");
          } else {
            // Manejo mejorado de errores del backend
            if (response.data && response.data.msg) {
              const errors = response.data.msg;

              // Si es un objeto de errores de validación
              if (typeof errors === 'object') {
                const firstError = Object.values(errors)[0];
                const errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;

                Alerts({
                  msg: "Error",
                  title: errorMessage || "Error al cambiar la contraseña",
                  code: "400",
                  type: "error",
                });
              } else {
                // Si es un string directo
                Alerts({
                  msg: "Error",
                  title: errors,
                  code: "400",
                  type: "error",
                });
              }
            } else {
              Alerts({
                msg: "Error",
                title: "Token inválido o expirado. Solicita uno nuevo.",
                code: "400",
                type: "error",
              });
            }
          }
        }
        break;

      default:
        break;
    }
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "password":
      case "confirm_password":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <CambiarContraseña
      onChange={onChange}
      onClick={onClick}
      form={form}
      loading={loading}
      show={show}
      setShow={setShow}
    />
  );
};

export default ContraseñaController;
